import React, { Component } from 'react';

import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import mgm from '../../_redux/actions/api/mgm';

import TagManager from 'react-gtm-module';

import FormCreditCard from '../../Components/FormCreditCard';
import OrderResume from '../../Components/OrderResume';
import Loading from '../../Components/Loading';

import NavBtn from '../../Components/NavBtn';

import {
	setCreditPayment,
	setBoletoPayment,
	getBankSlip
} from '../../_redux/actions/payment';

import { userLogin } from '../../_redux/actions/auth';
import { getPlanList } from '../../_redux/actions/plan';
import { getOrderValue } from '../../_redux/actions/order';
import { setAllValues } from '../../_redux/actions/allValues';

import { redirectToStore } from '../../utils/stores';
import StepCounter from '../../Components/StepCounter';
import {
	getOrderPharmaceutical,
	sendSmsPharmaceutical
} from '../../utils/orderService.js';
import {
	FaExclamationTriangle,
	FaThumbsUp,
	FaCreditCard,
	FaBarcode,
	FaMoneyBill
} from 'react-icons/fa';
import { FiAlertCircle } from 'react-icons/fi';
import Header from '../../Components/Header';

import { hotjar } from 'react-hotjar';
import { PageView, initGA } from '../../Components/Tracking';
import { handleEPaySubmit } from '../../utils/epayServices';
import { handleVivoSubmit } from '../../utils/vivoServices';
import { handlePosOrCashSubmit, verifyStoneId } from '../../utils/posServices';
import { handleAdyenSubmit, checkCreditAdyen } from '../../utils/adyenServices';
import { ThemeProvider } from 'styled-components';
import ThemeSelector from '../../style/themes/ThemeSelector';
import FormField from '../../style/styledComponents/FormField';
import TitlePayment from '../../style/styledComponents/TitlePayment';
import NavTabPayment from '../../style/styledComponents/NavTabPayment';
import FormWrapper from '../../style/styledComponents/FormWrapper';
import TermAndConditions from '../../Components/TermAndConditions';
import FormPos from '../../Components/FormPos';
// import FormCash from '../../Components/FormCash';
import FormAdyen from '../../Components/FormAdyen';
import Pharmaceutical from '../../Components/Pharmaceutical';
import PharmaceuticalModal from '../../Components/PharmaceuticalModal';

import BoxSize from '../../style/styledComponents/BoxSize';
import Container from '../../style/styledComponents/Container';
import cmDrConsulta from '../../_redux/actions/api/cmDrConsulta';
import { handleLevelledSubmit } from '../../utils/levelledServices';
import Captcha from '../../utils/Captcha.js'
import { RECAPTCHA_ACTIONS } from '../../utils/Captcha.js'
import planEnum from '../../Enums/PlanEnum.js'

class Pagamento extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			loadingPharm: true,
			error: null,
			errorFunc: null,
			termos: false,
			termos2: false,
			termos3: false,
			url: '',
			hasGracePeriod: '',
			errorMsg: '',
			showCartaoForm: true,
			showBoletoForm: true,
			formOfPayment: 'Cartão',
			cardPayment: null,
			posPayment: null,
			adyenPayment: null,
			// cashPayment: null,
			isComplete: false,
			isEPay: false,
			timeout: false,
			isVivo: false,
			isCmDrConsulta: false,
			isSignatureChosen: false,
			newTermos: false,
			showTitle: true,
			// showPosForm: false, ---- Metodo de pagamento utizando Stone ----
			// showDinheiroForm: false,
			showAdyenForm: false,
			paymentMethodBoleto: false,
			paymentMethodCard: false,
			isLevelled: false,
			terminal: [],
			pharmaceuticalCode: '',
			showModal: false,
			buttonDisabled: false
		};

		this.FormCreditCard = React.createRef();

		this.sendPayment = this.sendPayment.bind(this);
		this.sendEPayPayment = this.sendEPayPayment.bind(this);
		this.sendVivoPayment = this.sendVivoPayment.bind(this);
		//this.sendPaymentPos = this.sendPaymentPos.bind(this); ---- Metodo de pagamento utizando Stone ----
		this.sendPaymentAdyen = this.sendPaymentAdyen.bind(this);
		// this.sendPaymentDinheiro = this.sendPaymentDinheiro.bind(this);
		this.formData = this.formData.bind(this);
		this.sendPayment = this.sendPayment.bind(this);
		this.sendPaymentCartao = this.sendPaymentCartao.bind(this);
		this.sendPaymentBoleto = this.sendPaymentBoleto.bind(this);
		this.sendSmsPharm = this.sendSmsPharm.bind(this);
		this.errorAccept = this.errorAccept.bind(this);
		this.changeTerm = this.changeTerm.bind(this);
		this.changeTerm2 = this.changeTerm2.bind(this);
		this.changeTerms = this.changeTerms.bind(this);
		this.goBack = this.goBack.bind(this);
		this.doNotSend = this.doNotSend.bind(this);
		this.handleIsComplete = this.handleIsComplete.bind(this);
		this.handleIsCompleteBoleto = this.handleIsCompleteBoleto.bind(this);
		// this.handleIsCompletePos = this.handleIsCompletePos.bind(this); ---- Metodo de pagamento utizando Stone ----
		this.handleIsCompleteAdyen = this.handleIsCompleteAdyen.bind(this);
		// this.handleIsCompleteDinheiro = this.handleIsCompleteDinheiro.bind(this);
		this.handleGtmFormatData = this.handleGtmFormatData.bind(this);
		this.handleGtm = this.handleGtm.bind(this);
		// this.formDataPos = this.formDataPos.bind(this); ---- Metodo de pagamento utizando Stone ----
		// this.formDataCash = this.formDataCash.bind(this);
		this.formDataAdyen = this.formDataAdyen.bind(this);
		this.onPixSelected = this.onPixSelected.bind(this);
		this.fieldsTouched = false;
		this.sendLevelledPayment = this.sendLevelledPayment.bind(this);
		this.captcha = new Captcha()
	}

	async componentDidMount() {
		if (this.verifyOrderContinued()) {
			const { email, order: orderId } = this.getParamsUrl();
			await this.setPharmaceuthicalOrderInfos(email, orderId);
		}

		// importa recaptcha
		this.captcha.importScript()

		const planType = sessionStorage.getItem('planType');
		let { Subscription, Order, Plan } = this.props;
		const checkPaymentOptions = Plan.list[0];
		const {
			GiftCode,
			VivoUser,
			CmDrConsulta,
			SignatureChosen,
			Levelled,
			Campaign
		} = this.props;

		const utmTerm = Campaign.info.utmTerm;

		const monthlyPlans = [
			planEnum.dr_consulta_anual_subscrição_mensal,
			planEnum.dr_consulta_odonto_anual_subscrição_mensal,
			planEnum.dr_consulta_semestral_subscrição_mensal
		]

		this.props.getOrderValue(Order.data.orderId, CmDrConsulta.paymentMethod.pix);

		if (Object.keys(GiftCode.data).length > 0) {
			this.setState({ isEPay: true, newTermos: true, showTitle: false });
		} else if (Object.keys(VivoUser.data).length > 0) {
			this.setState({ isVivo: true, newTermos: true, showTitle: false });
		} else if (Object.keys(CmDrConsulta.data).length > 0) {
			this.setState({
				// showPosForm: true, ---- Metodo de pagamento utizando Stone ----
				// showDinheiroForm: true,
				showAdyenForm: true,
				isCmDrConsulta: true,
				newTermos: false,
				showTitle: false,
				formOfPayment: 'POS'
			});

			const terminal = await cmDrConsulta.getTerminal(utmTerm);

			this.setState({ terminal: terminal.data });
		} else if (Object.keys(SignatureChosen.data).length > 0) {
			this.setState({
				isSignatureChosen: true,
				newTermos: false,
				showTitle: false
			});
		} else if (Object.keys(Levelled.data).length > 0) {
			this.setState({ isLevelled: true, newTermos: true, showTitle: false });
		}
		if (checkPaymentOptions && checkPaymentOptions.has_bank_slip === '0') {
			this.setState({ showBoletoForm: false });
		}
		if (checkPaymentOptions && checkPaymentOptions.has_credit_card === '0') {
			this.setState({ showCartaoForm: false });
		}

		if(monthlyPlans.includes(Number(SignatureChosen.data.planId))) {
			this.setState({ showBoletoForm: false });
		}
		//await mgm.loginMgm();
		if (!Order.data.orderId) {
			redirectToStore();
		}

		const { loja } = this.props.match.params;
		initGA();
		PageView(`/loja/${loja}/pagamento`);
		hotjar.initialize(937897, 6);
		/*if (planType === 'saude' && loja !== 'vivoavulso') {
			const payer = Subscription.data.itens[0];

			if (payer) {
				let formattedName = payer.name.replace(' ', '-').toLowerCase();
				let formattedCpf = payer.cpf.replace(/[.]/g, '').replace('-', '');
				let dataMgm = {
					source: 'MGM',
					medium: formattedCpf,
					campaign: formattedName,
					content: 'pagina-sucesso-compra'
				};
				try {
					const res = await mgm.indication(dataMgm);
					this.setState({ url: res.data });
				} catch (err) {}
			}
		} */
		if (window.jQuery) {
			let $ = window.jQuery;
			$('.nav-tabs a').on(
				'shown.bs.tab',
				function(event) {
					let formOfPayment = $(event.target).text();
					this.setState({ formOfPayment: formOfPayment });
				}.bind(this)
			);
			$(document).ready(function() {
				$(this).scrollTop(0);
			});
		}
	}

	goBack() {
		let { loja } = this.props.match.params;

		if (
			this.state.isEPay ||
			this.state.isVivo ||
			this.state.isCmDrConsulta ||
			this.state.isSignatureChosen ||
			this.state.isLevelled
		) {
			this.props.history.replace(
				process.env.PUBLIC_URL + `/${loja}/enderecoBeneficiario`
			);
		} else {
			this.props.history.replace(process.env.PUBLIC_URL + `/${loja}/carrinho`);
		}
	}

	async sendPaymentCartao() {
		const action = RECAPTCHA_ACTIONS.CHECKOUT
		const token = await this.captcha.generateToken(action)
		let { Order } = this.props;
		let prom = this.handleGtmFormatData().prom;
		const yaloProm = prom === '' ? null : prom;
		if (Order.data.orderId && !this.checkData(this.data)) {
			this.setState({
				loading1: true
			});
			var valida = 'falso';

			var pagamentoId = this.props.setCreditPayment(
				Order.data.orderId,
				[this.data],
				valida,
				yaloProm,
				token,
				action
			);
			pagamentoId.then(valor => {
				var count = 0;
				var intervalID = (this.interval = setInterval(() => {
					valida = 'verdadeiro';
					var result = this.props.setCreditPayment(
						valor,
						[this.data],
						valida,
						null,
						null,
						null
					);
					result.then(valor => {
						if (valor === 'true') {
							this.handleGtm('orderFailed');

							this.setState({
								loading1: false,
								title: 'Ops!',
								error:
									'Não conseguimos processar o seu cartão de crédito. Por favor, confirme as bandeiras aceitas, revise os dados preenchidos e tente novamente. Caso o erro persista, tente com outro cartão ou ligue para a YALO no 4000-1664, para capitais e regiões metropolitanas ou 4000-1664, para demais regiões. Como outra opção, você pode escolher o boleto.'
							});
							clearInterval(intervalID);
						} else if (valor === 'true1') {
							let { Payment } = this.props;
							this.handleGtm('orderFailed');

							this.setState({
								loading1: false,
								title: Payment.data.error_message_title,
								error1: Payment.data.error_message_body
							});
							clearInterval(intervalID);
						} else if (valor === 'false') {
							clearInterval(intervalID);
							this.handleGtm('orderPlaced');
							this.handleRedirectToSuccess();
						}
					});

					count++;
					if (count === 20) {
						clearInterval(intervalID);
						this.setState({
							timeout: true
						});
						this.handleGtm('orderPlaced');

						this.handleRedirectToSuccess();
					}
				}, 6000));
			});
		} else {
			this.handleGtm('orderFailed');

			this.setState({
				title: 'Erro no cartão!',
				error:
					'Não conseguimos processar o seu cartão de crédito. Por favor, confirme as bandeiras aceitas, revise os dados preenchidos e tente novamente. Caso o erro persista, tente com outro cartão ou ligue para a YALO no 4000-1664, para capitais e regiões metropolitanas ou 4000-1664, para demais regiões. Como outra opção, você pode escolher o boleto.'
			});
		}
	}

	sendPaymentBoleto() {
		let prom = this.handleGtmFormatData().prom;
		const yaloProm = prom === '' ? null : prom;

		if (this.state.termos) {
			let { Order } = this.props;
			if (Order.data.orderId) {
				this.setState({
					loading1: true
				});
				const paymentId = this.props.setBoletoPayment(
					Order.data.orderId,
					yaloProm
				);
				paymentId.then(value => {
					if (!value) {
						// error
					}
					var count = 0;
					var intervalID = (this.interval = setInterval(() => {
						var isSuccess = this.props.getBankSlip(value);
						isSuccess.then(value => {
							if (value === 'false') {
								this.handleGtm('orderFailed');

								this.setState({
									loading1: false,
									title: 'Ops!',
									error: 'Não conseguimos pegar seu boleto.'
								});
								clearInterval(intervalID);
							} else if (value === 'true') {
								clearInterval(intervalID);
								this.handleGtm('orderPlaced');

								this.handleRedirectToSuccess();
							}
						});

						count++;
						if (count === 20) {
							clearInterval(intervalID);
							this.setState({ timeout: true });
							this.handleGtm('orderPlaced');

							this.handleRedirectToSuccess();
						}
					}, 6000));
				});
			} else {
				this.setState({
					error: 'Houve um erro inesperado, favor tente novamente',
					errorFunc: () => {
						redirectToStore();
					}
				});
			}
		} else {
			this.setState({
				errorMsg: 'É necessário aceitar os termos para continuar'
			});
		}
		//  else {
		// 	if (this.state.termos) {
		// 		this.setState({
		// 			error: 'É necessário aceitar os termos da Política de Privacidade.'
		// 		});
		// 	} else {
		// 		this.setState({
		// 			error: 'É necessário aceitar os Termos e Condições do Produto.'
		// 		});
		// 	}
		// }
	}

	formData(data) {
		this.data = data;
	}
	/* ---- Metodo de pagamento utizando Stone ----
	formDataPos(data) {
		this.dataPos = data;
	}
	*/
	formDataAdyen(data) {
		this.dataAdyen = data;
	}
	
	onPixSelected(paymentMethodPix){
		const {Order } = this.props;
		this.props.getOrderValue(Order.data.orderId, paymentMethodPix);
	}

	/* formDataCash(data) {
		this.dataCash = data;
	} */

	checkData(data) {
		var checkField = {
			cardNumber: {
				regex: /^([0-9]{16})|(3[47][0-9]{13})$/i,
				errorMsg: 'Número do cartão inválido'
			},
			cardName: {
				regex: /^([\s]?([a-zà-ú])+\s)+([a-zà-ú])+[\s]?$/i,
				errorMsg: 'Nome do cartão inválido'
			},
			cardExpirationMonth: {
				regex: /^(1[0-2])|(0[1-9])$/i,
				errorMsg: 'Validade do cartão inválido'
			},
			cardExpirationYear: {
				regex: /^(2[0])([2-9][0-9])$/i,
				errorMsg: 'Validade do cartão inválido'
			},
			cardCVV: {
				regex: /^([0-9]{3,4})$/i,
				errorMsg: 'CVV do cartão inválido'
			}
		};

		let error = false;

		for (var fieldName in checkField) {
			if (fieldName !== 'posNumber') {
				if (!checkField[fieldName].regex.test(data[fieldName])) {
					error = true;

					this.setState({
						error: checkField[fieldName].errorMsg
					});
				}
			}
		}
		return error;
	}

	errorAccept() {
		if (this.state.errorFunc) {
			this.state.errorFunc();
		}
		this.setState({
			error: null,
			error1: null,
			errorFunc: null
		});
	}

	getPlanData(planId) {
		let { Plan } = this.props;

		let planData = {};

		Plan.list.forEach(planItem => {
			if (planItem.planId === planId) {
				planData = planItem;
			}
		});

		return planData;
	}

	changeTerm(e) {
		const isChecked = this.state.termos ? true : false;
		this.setState({
			termos: e.target.checked,
			errorMsg: isChecked
		});
		this.handleIsCompleteBoleto(isChecked);
	}

	changeTerm2(e) {
		this.setState({
			termos2: e.target.checked
		});
	}

	changeTerms(e, term) {
		this.setState(
			{
				[term]: e.target.checked
			},
			() => {
				if (this.state.termos && this.state.termos2 && this.state.termos3) {
					this.setState({ isComplete: true });
				} else {
					this.setState({ isComplete: false });
				}
			}
		);
	}

	findPlanById(planId) {
		let dataReturn = null;
		let { Plan } = this.props;
		if (!Plan.list.error) {
			Plan.list.forEach(planItem => {
				if (planItem.planId === planId) {
					dataReturn = planItem;
				}
			});
		}

		return dataReturn;
	}

	handleGtmFormatData() {
		let data = this.data;

		let numberOfInstallment = data.numberOfInstallment;
		let { Payment, Order, Subscription, Cupom } = this.props;
		let { loja } = this.props.match.params;
		let planType = sessionStorage.getItem('planType');
		// Obtém a data/hora atual
		let date = new Date();

		let day = date.getDate(); // 1-31
		let month = date.getMonth(); // 0-11 (zero=janeiro)
		let year = date.getFullYear(); // 4 dígitos
		let hour = date.getHours(); // 0-23
		let minute = date.getMinutes();
		// Formata a data e a hora (note o mês + 1)
		var str_date =
			year + '-' + (month + 1) + '-' + day + ' ' + hour + ':' + minute;

		let sendCpf = '';
		if (Subscription.data.itens.length) {
			sendCpf = Subscription.data.itens[0].cpf
				.replace(/[.]/g, '')
				.replace('-', '');
		}

		let planData = this.findPlanById(Order.data.planId);
		let planTime =
			planData.numberOfInstallment === '1'
				? 'mensal'
				: planData.numberOfInstallment === '3'
				? 'trimestral'
				: planData.numberOfInstallment === '6'
				? 'semestral'
				: planData.numberOfInstallment === '12'
				? 'anual'
				: '';

		let valueTotal = Order.value.total;
		let link = null;
		let paymentMethod;
		let successReponse;
		paymentMethod = this.state.formOfPayment === 'Cartão' ? 'cartao' : 'boleto';

		if (paymentMethod === 'cartao') {
			successReponse =
				this.state.timeout === true
					? 'pedido_enviado_cartao'
					: Payment.data.status === 'paid'
					? 'sucesso_cartao'
					: //	: Payment.data.success === false
					  //	? 'falha_cartao'
					  'falha_cartao';
		} else if (paymentMethod === 'boleto') {
			successReponse =
				this.state.timeout === true
					? 'pedido_enviado_boleto'
					: Payment.data.status === 'sended'
					? 'sucesso_boleto'
					: 'falha_boleto';
			link = Payment.data.bank_slip_url;
			numberOfInstallment = 1;
		}
		let prazoContratado = planType.toLowerCase() + '_' + planTime;

		/*if (Payment.data.status === 'paid') {
			successReponse = 'successCard';
		} else {
			successReponse = 'quaseCard';
		}*/

		const orderId = Order.data.orderId;
		const planId = Order.data.planId;
		const planName = planData.name_description;
		const planPrice = planData.price;
		const quantity = Subscription.data.itens.length;
		const cupomId = Cupom.data.cupomId;
		const signatureType = planData.signature_type;
		const dependentIsActive = planData.active_dependents;
		// const formulario_conversao = sessionStorage.getItem('formulario_conversao') || localStorage.getItem('formulario_conversao') || 'pedido_iniciado';
		const prom =
			sessionStorage.getItem('yaloProm') ||
			localStorage.getItem('yaloProm') ||
			'';
		const birthdaySplit = Subscription.data.itens[0].birthday.split('/');
		const birthday =
			birthdaySplit[2] + '-' + birthdaySplit[1] + '-' + birthdaySplit[0];

		const orderPlaced = {
			ecommerce: {
				purchase: {
					actionField: {
						id: orderId, //ID do Pedido
						affiliation: 'YALO', //"Yalo"
						revenue: parseFloat(valueTotal), //Preço total a vista com o desconto do cupom JÁ APLICADO
						tax: parseFloat(0.0), //0.00
						shipping: parseFloat(0.0), //0.00
						coupon: cupomId || '' //Código do CUPOM ("TESTEVIVO" por exemplo)
					},

					products: [
						{
							name: planName, //"YALO Fidelidade Trimestral"
							id: planId, //ID do produto
							price: parseFloat(planPrice), //Preço do produto a vista sem o desconto aplicado
							brand: 'YALO', //Fixo "YALO"
							category: planType, //YALO Fidelidade
							variant: prazoContratado, //Trimestral
							quantity: dependentIsActive == true ? 1 : quantity //Quantidade de assinaturas (Titular + Dependentes)
						}
					]
				}
			},
			cpf: sendCpf,
			resultado_pedido: successReponse,
			forma_de_pagamento: paymentMethod,
			loja: loja,
			tipo_assinatura: planType,
			prazo_contratado: prazoContratado,
			valor_pedido: valueTotal,
			numero_parcelas: numberOfInstallment,
			data_do_pedido: str_date,
			link_boleto: link,
			prom,
			data_de_nascimento: birthday,
			dependents:
				dependentIsActive == true && quantity > 0 ? quantity - 1 : null
		};

		return orderPlaced;
	}

	handleGtm(event) {
		const tagManagerArgs = {
			//gtmId: 'GTM-KGG5NJS', //QA
			//gtmId: 'GTM-W642D5X',
			gtmId: process.env.GTM
			// events: {
			// 	event: event
			// }
		};

		const orderPlaced = this.handleGtmFormatData();
		TagManager.initialize(tagManagerArgs);
		TagManager.dataLayer({
			dataLayer: {
				event: event,
				...orderPlaced
			}
		});
		console.debug('orderPlaced', orderPlaced);
	}

	handleRedirectToSuccess() {
		let { Payment, Order, Subscription } = this.props;
		let planType = sessionStorage.getItem('planType');
		let title = planType;
		let { loja } = this.props.match.params;

		let gracePeriod = '';
		let planSelected = Order.data.planId;
		let planData = this.findPlanById(planSelected);
		if (planData.hasGracePeriod === '1') {
			if (planData.gracePeriodTax != '0' && planData.gracePeriodTax != null) {
				gracePeriod = 'c';
			} else {
				gracePeriod = '';
			}
		} else {
			gracePeriod = 'g';
		}

		let hasUsedCard = '';
		hasUsedCard = planData.used_card === '1' ? 's' : 'n';
		hasUsedCard = title === 'individual' ? '' : hasUsedCard;

		let sendedCpf = '';
		if (Subscription.data.itens.length) {
			sendedCpf = Subscription.data.itens[0].cpf
				.replace(/[.]/g, '')
				.replace('-', '');
		}

		let successReponse = '';
		if (Payment.data.paymentMethod === 'boleto') {
			successReponse =
				Payment.data.bank_slip_url === null ? '' : 'successBoleto';
		} else if (Payment.data.status === 'paid') {
			successReponse = 'successCard';
		} else {
			successReponse = 'quaseCard';
		}
		let message = this.state.url;
		if (loja === 'vivovaloriza') {
			window.location =
				successReponse === 'successCard'
					? `https://yalo.com.br/sucessocartao?assinatura=${title}&carencia=g&loja=${loja}&em=${sendedCpf}`
					: successReponse === 'successBoleto'
					? `https://yalo.com.br/sucessoboleto?assinatura=${title}&carencia=g&loja=${loja}&btnBoleto=${Payment
							.data.boletoPDF || Payment.data.bank_slip_url}&em=${sendedCpf}`
					: `https://yalo.com.br/pedidoenviado?assinatura=${title}&carencia=g&loja=${loja}&em=${sendedCpf}`;
		} else {
			switch (successReponse) {
				case 'successCard':
					title === 'saude'
						? (window.location = `https://yalo.com.br/sucessocartao?assinatura=${title}&carencia=${gracePeriod}&cartao=s&loja=${loja}&em=${sendedCpf}`)
						: (window.location = `https://yalo.com.br/sucessocartao?assinatura=${title}&carencia=${gracePeriod}&loja=${loja}&em=${sendedCpf}`);
					break;
				case 'successBoleto':
					//Payment.data.boletoPDF
					title === 'saude'
						? (window.location = `https://yalo.com.br/sucessoboleto?assinatura=${title}&carencia=${gracePeriod}&cartao=s&loja=${loja}&btnBoleto=${Payment
								.data.boletoPDF || Payment.data.bank_slip_url}&em=${sendedCpf}`)
						: (window.location = `https://yalo.com.br/sucessoboleto?assinatura=${title}&carencia=${gracePeriod}&loja=${loja}&btnBoleto=${Payment
								.data.boletoPDF ||
								Payment.data.bank_slip_url}&em=${sendedCpf}`);
					//: window.location = `https://yalo.com.br/pedidoenviado?assinatura=${title}&carencia=${gracePeriod}`
					break;
				case 'quaseCard':
					window.location = `https://yalo.com.br/pedidoenviado?assinatura=${title}&carencia=${gracePeriod}&loja=${loja}&em=${sendedCpf}`;
					break;

				default:
					window.location = `https://yalo.com.br/pedidoenviado?assinatura=${title}&loja=${loja}&em=${sendedCpf}`;
					break;
			}
		}
	}

	sendLevelledPayment() {
		let { Subscription } = this.props;
		let planType = sessionStorage.getItem('planType');
		let title = planType;
		let sendedCpf = '';
		if (Subscription.data.itens.length) {
			sendedCpf = Subscription.data.itens[0].cpf
				.replace(/[.]/g, '')
				.replace('-', '');
		}
		if (this.state.termos) {
			this.setState({
				loading1: true
			});
			const {
				Address: { delivery },
				Subscription,
				Levelled: { data }
			} = this.props;
			var result = handleLevelledSubmit(delivery, Subscription, data);
			result.then(valor => {
				if (valor.status === 'success') {
					window.location = `https://yalo.com.br/sucessocartao?assinatura=${title}&carencia=g&loja=levelled&em=${sendedCpf}`;
				} else {
					this.setState({
						loading1: false,
						title: 'Ops!',
						error:
							'Não conseguimos processar o seu voucher. Caso o erro persista, ligue para a YALO no 4000-1664, para capitais e regiões metropolitanas ou 4000-1664, para demais regiões.'
					});
				}
			});
		} else {
			this.setState({
				loading: false,
				errorMsg: 'É necessário aceitar os termos para continuar'
			});
		}
	}

	sendEPayPayment() {
		let { Subscription } = this.props;
		let planType = sessionStorage.getItem('planType');
		let title = planType;
		let sendedCpf = '';
		if (Subscription.data.itens.length) {
			sendedCpf = Subscription.data.itens[0].cpf
				.replace(/[.]/g, '')
				.replace('-', '');
		}
		if (this.state.termos) {
			this.setState({
				loading1: true
			});
			const {
				Address: { delivery },
				Subscription,
				GiftCode: { data }
			} = this.props;
			var result = handleEPaySubmit(delivery, Subscription, data);
			result.then(valor => {
				if (valor.status === 'success') {
					this.setState({
						loading1: false
					});

					window.location = `https://yalo.com.br/sucessocartao?assinatura=${title}&carencia=g&loja=epay&em=${sendedCpf}`;
				} else {
					this.setState({
						loading1: false,
						title: 'Ops!',
						error:
							'Não conseguimos processar o seu voucher. Caso o erro persista, ligue para a YALO no 4000-1664, para capitais e regiões metropolitanas ou 4000-1664, para demais regiões.'
					});
				}
			});
		} else {
			this.setState({
				loading: false,
				errorMsg: 'É necessário aceitar os termos para continuar'
			});
		}
	}
	sendVivoPayment() {
		let { Subscription } = this.props;
		let planType = sessionStorage.getItem('planType');
		let title = planType;
		let sendedCpf = '';
		if (Subscription.data.itens.length) {
			sendedCpf = Subscription.data.itens[0].cpf
				.replace(/[.]/g, '')
				.replace('-', '');
		}
		if (this.state.termos) {
			this.setState({
				loading1: true
			});
			const {
				Address: { delivery },
				Subscription,
				VivoUser: { data }
			} = this.props;
			var result = handleVivoSubmit(delivery, Subscription, data);
			result.then(valor => {
				if (valor === false) {
					//if (true) {
					this.setState({
						loading1: false
					});

					window.location = `https://yalo.com.br/sucessocartao?assinatura=${title}&carencia=vivoavulso&loja=vivoavulso&em=${sendedCpf}`;
				} else {
					this.setState({
						loading1: false,
						title: 'Ops!',
						error:
							'Não conseguimos processar o seu pedido. Caso o erro persista, ligue para a YALO no 4000-1664, para capitais e regiões metropolitanas ou 4000-1664, para demais regiões.'
					});
				}
			});
		} else {
			this.setState({
				loading: false,
				errorMsg: 'É necessário aceitar os termos para continuar'
			});
		}
	}
	/* ---- Metodo de pagamento utizando Stone ----
		sendPaymentPos() {
			const { Subscription, CmDrConsulta } = this.props;
			let planType = sessionStorage.getItem('planType');
			let title = planType;
			let sendedCpf = '';
			if (Subscription.data.itens.length) {
				sendedCpf = Subscription.data.itens[0].cpf
					.replace(/[.]/g, '')
					.replace('-', '');
			}

			this.setState({
				loading1: true
			});
			const {
				Address: { delivery }
				//		Pos: { data }
			} = this.props;

			var hasStoneId = verifyStoneId(this.dataPos.paymentReceipt);
			hasStoneId.then(data => {
				if (data && data.length === 0) {
					var result = handlePosOrCashSubmit(
						delivery,
						Subscription,
						[this.dataPos],
						CmDrConsulta.data
					);
					result.then(valor => {
						if (valor.status === 'success') {
							window.location = `https://yalo.com.br/sucessocartao?assinatura=${title}&carencia=g&loja=cmdrconsulta&em=${sendedCpf}`;
						} else {
							this.setState({
								loading1: false,
								title: 'Ops!',
								error: 'Tente novamente.'
							});
						}
					});
				} else {
					this.setState({
						loading1: false,
						title: 'Ops!',
						error: 'STONEID inválido.'
					});
				}
			});
		}
	*/

	
	sendPostMessage = (message) => {
		if (window.opener){
			window.opener.postMessage(message, "http://localhost:4000/s2-drconsulta.html");
			window.opener.postMessage(message, "https://s2homolog.drconsulta.com");
			window.opener.postMessage(message, "https://s2dockerdev.drconsulta.com");
			window.opener.postMessage(message, "https://s2.drconsulta.com");
			window.opener.postMessage(message, "https://s2dev.drconsulta.com:2454");
		} 
		return;
	};

	sendPaymentAdyen() {
		const { Subscription } = this.props;

		const orderId = Subscription.data.itens[0].orderId;
		let planType = sessionStorage.getItem('planType');
		let title = planType;
		let sendedCpf = '';
		if (Subscription.data.itens.length) {
			sendedCpf = Subscription.data.itens[0].cpf
				.replace(/[.]/g, '')
				.replace('-', '');
		}

		this.setState({ loading1: true });

		var count = 0;
		var result = handleAdyenSubmit(orderId, this.dataAdyen);
		result.then(res => {
			console.log('entrei');
			if (res.httpStatus === 200) {
				var interval = (this.interval = setInterval(() => {
					const response = checkCreditAdyen(orderId);
					response.then(result => {
						console.log('result false', result);
						if (result.status === 200) {
							if (result.data === 'paid') {
								this.sendPostMessage("completed_card_sale");								
								window.location = `https://yalo.com.br/sucessocartao?assinatura=${title}&carencia=g&loja=cmdrconsulta&em=${sendedCpf}`;
								clearInterval(interval);
							} else if (result.data === 'failed') {
								this.sendPostMessage("error_card_sale");
								this.setState({
									loading1: false,
									title: 'Ops!',
									error: 'Tente novamente.'
								});
								clearInterval(interval);
							}
						} else {
							this.sendPostMessage("error_card_sale");
							this.setState({
								loading1: false,
								title: 'Ops!',
								error: 'Pedido de pagamento não encontrado.'
							});
							clearInterval(interval);
						}
					});

					count++;
					if (count === 20) {
						this.sendPostMessage("error_card_sale");
						this.setState({
							// timeout: true,
							loading1: false,
							title: 'Ops!',
							error: 'Tente novamente.'
						});
						clearInterval(interval);
					}
				}, 6000));
			} else {
				this.sendPostMessage("error_card_sale");
				this.setState({
					loading1: false,
					title: 'Ops!',
					error: 'Tente novamente.'
				});
				clearInterval(interval);
							}
		});
	}

	/* sendPaymentDinheiro() {
		const { Subscription, CmDrConsulta } = this.props;
		let planType = sessionStorage.getItem('planType');
		let title = planType;
		let sendedCpf = '';
		if (Subscription.data.itens.length) {
			sendedCpf = Subscription.data.itens[0].cpf
				.replace(/[.]/g, '')
				.replace('-', '');
		}

		this.setState({
			loading1: true
		});
		const {
			Address: { delivery }
		} = this.props;
		var result = handlePosOrCashSubmit(
			delivery,
			Subscription,
			[this.dataCash],
			CmDrConsulta.data
		);
		result.then(valor => {
			if (valor.status === 'success') {
				window.location = `https://yalo.com.br/sucessocartao?assinatura=${title}&carencia=g&loja=cmdrconsulta&em=${sendedCpf}`;
			} else {
				this.setState({
					loading1: false,
					title: 'Ops!',
					error: 'Tente novamente.'
				});
			}
		});
	} */

	sendPayment() {
		this.fieldsTouched = true;

		this.state.formOfPayment === 'Cartão'
			? this.setState({ cardPayment: true })
			: this.state.formOfPayment === 'POS'
			? this.setState({ posPayment: true })
			: this.state.formOfPayment === 'Adyen'
			? this.setState({ adyenPayment: true })
			: /* this.state.formOfPayment === 'Dinheiro'
			? this.setState({ cashPayment: true })
			: */ this.sendPaymentBoleto();
	}
	doNotSend() {
		this.setState({
			cardPayment: false,
			posPayment: false,
			adyenPayment: false
			// cashPayment: false
		});
	}

	handleIsCompleteAdyen(check) {
		this.setState({
			cleanForm: false,
			formOfPayment: 'Adyen'
		});

		this.setState({
			isComplete: this.state.previousStateCard
		});

		let isIncomplete = false;

		for (let field in this.dataAdyen) {
			if (this.dataAdyen[field] === undefined) {
				isIncomplete = true;
			}
		}
		if (isIncomplete) {
			this.setState({
				isComplete: false,
				previousStateCard: false
			});
		} else {
			if (check !== true && check !== false) {
				this.setState({
					isComplete: this.state.previousStateCard1
				});
			} else {
				if (check) {
					this.setState({
						isComplete: false,
						previousStateCard: false,
						previousStateCard1: false
					});
				} else {
					this.setState({
						isComplete: true,
						previousStateCard: true,
						previousStateCard1: true
					});
				}
			}
		}
	}

	/* ---- Metodo de pagamento utizando Stone ----
		handleIsCompletePos(checkIfComplete) {
			this.setState({
				cleanForm: false,
				formOfPayment: 'POS'
			});

			this.setState({
				isComplete: this.state.previousStateCard
			});

			let isIncomplete = false;

			for (let field in this.dataPos) {
				if (this.dataPos[field] === undefined) {
					isIncomplete = true;
				}
			}
			if (isIncomplete) {
				this.setState({
					isComplete: false,
					previousStateCard: false
				});
			} else {
				if (checkIfComplete !== true && checkIfComplete !== false) {
					this.setState({
						isComplete: this.state.previousStateCard1
					});
				} else {
					if (checkIfComplete) {
						this.setState({
							isComplete: false,
							previousStateCard: false,
							previousStateCard1: false
						});
					} else {
						this.setState({
							isComplete: true,
							previousStateCard: true,
							previousStateCard1: true
						});
					}
				}
			}
		}
	*/

	handleIsComplete(checkComplete) {
		this.setState({
			cleanForm: false,
			formOfPayment: 'Cartão'
		});
		this.setState({
			isComplete: this.state.previousStateCard
		});

		let isIncomplete = false;

		for (let field in this.data) {
			if (this.data[field] === undefined) {
				isIncomplete = true;
			}
		}

		if (isIncomplete) {
			this.setState({
				isComplete: false,
				previousStateCard: false
			});
		} else {
			if (checkComplete !== true && checkComplete !== false) {
				this.setState({
					isComplete: this.state.previousStateCard1
				});
			} else {
				if (checkComplete) {
					this.setState({
						isComplete: false,
						previousStateCard: false,
						previousStateCard1: false
					});
				} else {
					this.setState({
						isComplete: true,
						previousStateCard: true,
						previousStateCard1: true
					});
				}
			}

			//	}
		}
	}

	handleIsCompleteBoleto(isChecked) {
		if (isChecked !== true && isChecked !== false) {
			let setState = this.state.previousState ? true : false;
			this.setState({
				isComplete: setState,
				formOfPayment: 'Boleto'
			});
		} else {
			if (isChecked) {
				this.setState({ isComplete: false, previousState: false });
			} else {
				this.setState({
					isComplete: true,
					previousState: true
				});
			}
		}
	}

	/* handleIsCompleteDinheiro(isChecked) {
		this.setState({
			cleanForm: false,
			formOfPayment: 'Dinheiro'
		});

		this.setState({
			isComplete: this.state.previousState
		});

		let isIncomplete = false;

		for (let field in this.dataCash) {
			if (this.dataCash[field] === undefined) {
				isIncomplete = true;
			}
		}
		if (isIncomplete) {
			this.setState({
				isComplete: false,
				previousState: false
			});
		} else {
			if (isChecked !== true && isChecked !== false) {
				let setState = this.state.previousState ? true : false;

				this.setState({
					isComplete: setState
				});
			} else {
				if (isChecked) {
					this.setState({
						isComplete: false,
						previousState: false
					});
				} else {
					this.setState({
						isComplete: true,
						previousState: true
					});
				}
			}
		}
	} */

	getParamsUrl() {
		let urlParams = this.props.location.search;

		if (urlParams.startsWith('?')) {
			urlParams = urlParams.substring(1);
		}

		const paramsObj = {};
		const paramsArray = urlParams.split('&');

		paramsArray.forEach(param => {
			const [key, value] = param.split('=');
			paramsObj[decodeURIComponent(key)] = decodeURIComponent(value);
		});

		return paramsObj;
	}

	async setPharmaceuthicalOrderInfos(email, orderId) {
		try {
		  await this.props.userLogin(email, '', true);
	  
		  const response = await getOrderPharmaceutical(orderId);
		  
		  const { store, subscriptions, dependents, payers, address, order, tracking_utm, plans, cupons } = response;
		  await this.props.getPlanList(store.identifier);
	  
		  sessionStorage.setItem('planType', store.identifier);
		  sessionStorage.setItem('dependentIsActive', '1');
	  
		  const allSubscriptions = [...[subscriptions], ...dependents];
	  
		  allSubscriptions.forEach(sub => {
			sub.phone = sub.phone ? `${sub.phone.substr(0, 2)} ${sub.phone.substr(2)}` : '';
			sub.birthday = sub.birthday ? moment(sub.birthday).format('DD/MM/YYYY') : '';
		  });
	  
		  this.props.setAllValues({
			Payer: {
			  list: [],
			  data: payers,
			},
			Subscription: {
			  data: {
				itens: allSubscriptions,
				error: {},
			  },
			  wait: {},
			  edit: {},
			},
			Address: {
			  data: {
				itens: [],
			  },
			  delivery: address,
			},
			Order: {
			  data: order,
			  value: {},
			},
			Campaign: {
			  wait: {
				...tracking_utm,
				formulario_de_conversao: 'pedido_iniciado',
			  },
			  data: {},
			  info: {},
			},
			SignatureChosen: {
			  data: plans,
			},
			Cupom: {
			  data: cupons[0] || {},
			},
		  });
	  
		  this.setState({ loadingPharm: false });
		} catch (error) {
		  console.error('Erro ao configurar informações da ordem farmacêutica:', error);
		}
	  }

	verifyOrderContinued() {
		const { email, order: orderId } = this.getParamsUrl();

		return email && orderId && this.props.Order.data.length == 0;
	}

	async sendSmsPharm(codePharm) {
		this.setState({ buttonDisabled: true });
		const { Order } = this.props;

		let response = await sendSmsPharmaceutical(Order.data.orderId, codePharm);

		if (response.data && response.data.statusCode == 200) {
			this.setState({ showModal: true });
		}else{
			this.setState({ buttonDisabled: false });
		}
	}

	render() {
		if (this.verifyOrderContinued()) {
			sessionStorage.setItem('isOrderContinued', true);
			if (this.state.loadingPharm) {
				return <Loading show={true}></Loading>;
			}
		}

		const isOrderContinued = sessionStorage.getItem('isOrderContinued');

		let { Order, Plan, SignatureChosen, Subscription, Campaign } = this.props;

		let plans = Plan.list;
		let { loja } = this.props.match.params;
		const plan = plans.find(p => p.planId === Order.data.planId);
		const forwardFunction = this.state.isEPay
			? this.sendEPayPayment
			: this.state.isVivo
			? this.sendVivoPayment
			: this.state.isLevelled
			? this.sendLevelledPayment
			: this.sendPayment;

		let totalValue =
			Number(Order.value.total) +
			Number(Order.value.delivery) +
			Number(Order.value.gracePeriodValue);

		let planData = this.getPlanData(Order.data.planId);

		let fieldError = '';
		if (this.state.error) {
			fieldError = (
				<div className='overlay'>
					<div className='overlay-box payment-error'>
						<div className='overlay-box--content '>
							<div className='overlay-align-title'>
								{/*<FaExclamationTriangle size={40} color={'red'}/>*/}
								<h2>{this.state.title}</h2>
							</div>
							<div className='overlay-box--content '>
								<p>{this.state.error}</p>
								{/*<img
									src={alertImg}
									alt='Erro'
									style={{ width: '44px' }}
									className='img-responsive payment-error-img'
								/>*/}
							</div>
						</div>
						<div className='overlay-button'>
							<button
								className='overlay-box--close f-bold btn-ok'
								onClick={this.errorAccept}>
								<FaThumbsUp size={18} color={'#0a53a6'} /> Ok
							</button>
						</div>
					</div>
				</div>
			);
		} else if (this.state.error1) {
			fieldError = (
				<div className='overlay'>
					<div className='overlay-box payment-error'>
						<div className='overlay-box--content'>
							<div className='overlay-align-title'>
								{/*<FaExclamationTriangle size={40} color={'red'}/>*/}
								<h2>{this.state.title}</h2>
							</div>
							<div className='overlay-box--content '>
								<p>{this.state.error1}</p>
							</div>
							<div className='overlay-button'>
								<button
									className='overlay-box--close f-bold btn-ok'
									onClick={this.errorAccept}>
									<FaThumbsUp size={18} color={'#0a53a6'} /> Ok
								</button>
							</div>
						</div>
					</div>
				</div>
			);
		}

		const planType = sessionStorage.getItem('planType');
		const title = planType;

		const classActive = !this.state.showCartaoForm ? 'active' : '';
		// const classActivePos = !this.state.showPosForm ? 'active' : ''; ---- Metodo de pagamento utizando Stone ----

		const pathArray = window.location.pathname.split('/');

		return (
			<ThemeProvider theme={ThemeSelector(pathArray[2])}>
				<Loading
					show={this.state.loading}
					show1={this.state.loading1}></Loading>
				{fieldError}

				{this.state.showModal && <PharmaceuticalModal message={'Sms enviado.'} />}

				<Header {...this.props} />
				<Container
					formOfPayment={this.state.formOfPayment}
					count={Subscription.data.itens.length}
					planType={planType}>
					<FormWrapper>
						<BoxSize>
							<div className='row'>
								{!isOrderContinued ? (
									<NavBtn
										goBack={this.goBack}
										goBackText={'VOLTAR'}
										goForward={false}
									/>
								) : null}

								<StepCounter
									assinatura={false}
									assinante={false}
									pagamento={true}
									endereco={false}
								/>
							</div>

							<OrderResume totalValue={totalValue} {...this.props} />
						</BoxSize>
						{Campaign.wait.utmSource == 'coop' && !isOrderContinued ? (
							<BoxSize>
								<Pharmaceutical onSend={this.sendSmsPharm} buttonDisabled={this.state.buttonDisabled} />
							</BoxSize>
						) : (
							<BoxSize>
								<div>
									<div className='form-step form-step-5'>
										{/* <div class="overlay">
													<div class="overlay-box">
														<div class="overlay-box--content">
															<h3 class="f-bold">Falta pouco</h3>
															<p>Escolha um endereço para receber seus cartões.</p>
														</div>
														<button class="overlay-box--close f-bold">Inserir endereço de entrega</button>
													</div>
												</div> */}

										{this.state.showTitle && (
											<TitlePayment style={{ marginTop: '20px' }}>
												<h4>Escolha como quer pagar:</h4>
											</TitlePayment>
										)}
										{/* <h3 className='visible-md visible-lg pay-title-desktop'>
												Escolha como quer pagar:
												</h3> */}
										<NavTabPayment
											style={{ marginTop: '20px' }}
											className='nav'
											role='tablist'>
											{this.state.showCartaoForm &&
												!this.state.isEPay &&
												!this.state.isVivo &&
												!this.state.isCmDrConsulta &&
												!this.state.isLevelled && (
													<li role='presentation' className='active'>
														<a
															onClick={this.handleIsComplete}
															href='#cartao'
															aria-controls='cartao'
															role='tab'
															id='style-cartao'
															data-toggle='tab'>
															<FaCreditCard size={25} />
															CARTÃO
														</a>
													</li>
												)}
											{this.state.showBoletoForm &&
												!this.state.isEPay &&
												!this.state.isVivo &&
												!this.state.isCmDrConsulta &&
												!this.state.isLevelled && (
													<li role='presentation' className={classActive}>
														{/* data-cy='btn-boleto' é ultilazada para selecionar o boleto em  testes desenvolvidos no cypress*/}
														<a
															data-cy='btn-boleto'
															onClick={this.handleIsCompleteBoleto}
															href='#boleto'
															aria-controls='boleto'
															role='tab'
															data-toggle='tab'>
															<FaBarcode size={25} />
															BOLETO
														</a>
													</li>
												)}{' '}
											{/* ---- Metodo de pagamento utizando Stone ----
											{this.state.showPosForm &&
												!this.state.isEPay &&
												!this.state.isVivo &&
												!this.state.isLevelled && (
												<li role='presentation' className='active'>
													<a
														onClick={this.handleIsCompletePos}
														href='#pos'
														aria-controls='pos'
														role='tab'
														data-toggle='tab'>
														<FaCreditCard size={25} />
														Maquininha
													</a>
												</li>
											)}
										*/}
										{this.state.showAdyenForm &&
											!this.state.isEPay &&
											!this.state.isVivo &&
											!this.state.isLevelled && (
												<li role='presentation' className='active'>
													<a
														onClick={() => this.handleIsCompleteAdyen()}
														href='#adyen'
														aria-controls='adyen'
														role='tab'
														data-toggle='tab'>
														<FaCreditCard size={25} />
														Adyen
													</a>
												</li>
											)}
										{/* {this.state.showDinheiroForm &&
												!this.state.isEPay &&
												!this.state.isVivo && (
													<li role='presentation' className={classActivePos}>
														<a
															onClick={this.handleIsCompleteDinheiro}
															href='#dinheiro'
															aria-controls='dinheiro'
															role='tab'
															data-toggle='tab'>
															<FaMoneyBill size={25} />
															Dinheiro
														</a>
													</li>
												)} */}
									</NavTabPayment>
									<div className='tab-content' style={{ marginTop: '20px' }}>
										{this.state.showCartaoForm &&
											!this.state.isEPay &&
											!this.state.isVivo &&
											!this.state.isCmDrConsulta &&
											!this.state.isLevelled && (
												<FormCreditCard
													onData={this.formData}
													onSend={this.sendPaymentCartao}
													goBack={this.goBack}
													installments={planData.numberOfInstallment}
													totalValue={totalValue}
													cardPayment={this.state.cardPayment}
													notSend={this.doNotSend}
													isCompleted={this.handleIsComplete}
													fieldsTouched={this.fieldsTouched}
													{...this.props}
												/>
											)}
										{/* {loja === 'vivoavulso' && (
											<div style={{ marginTop: '-20px' }}>
												<p>
													O pagamento da assinatura YALO é mensal e inclusa
													dentro da sua fatura VIVO.
												</p>
											</div>
										)} */}
										{/* data-cy='btn-slider' é ultilazada para selecionar o botão de confirmação de Termos, condições do produto e politica de privacidade em  testes desenvolvidos no cypress*/}
										{this.state.newTermos && (
											<div className='form-term'>
												<FormField>
													<FormField
														data-cy='btn-slider'
														className='form-terms'>
														<TermAndConditions changeTerm={this.changeTerm} />
														{this.state.errorMsg && this.state.errorMsg.length && (
															<div className='error-msg'>
																<FiAlertCircle size={13} />
																<small className='credit-card-error'>
																	{this.state.errorMsg}
																</small>
															</div>
														)}
													</FormField>
												</FormField>
											</div>
										)}
										<div
											role='tabpanel'
											className={`tab-pane ${classActive}`}
											id='boleto'>
											{this.state.showBoletoForm && (
												<>
													<h3>Informações de pagamento</h3>
													<p>
														A liberação dos seus benefícios começa a contar após
														a confirmação do pagamento, que pode levar até 2
														dias úteis. Se tiver urgência para usar os
														benefícios recomendamos o pagamento por cartão de
														crédito.
													</p>
												</>
											)}
											{/* data-cy='btn-slider' é ultilazada para selecionar o botão de confirmação de Termos, condições do produto e politica de privacidade em  testes desenvolvidos no cypress*/}
											{!this.state.isCmDrConsulta && (
												<FormField>
													<FormField
														data-cy='btn-slider'
														className='form-terms'>
														<TermAndConditions
															changeTerm={this.changeTerm}
															signatureChosen={SignatureChosen.data}
														/>
														{this.state.errorMsg && this.state.errorMsg.length && (
															<div className='error-msg'>
																<FiAlertCircle size={13} />
																<small className='credit-card-error'>
																	{this.state.errorMsg}
																</small>
															</div>
														)}
													</FormField>
												</FormField>
											)}
										</div>

										{/* ---- Metodo de pagamento utizando Stone ----
										 {this.state.showPosForm && (
											<div role='tabpanel' className='tab-pane ' id='pos'>
												<FormPos
													signatureType={title}
													onDataPos={this.formDataPos}
													posPayment={this.state.posPayment}
													isCompleted={this.handleIsCompletePos}
													notSend={this.doNotSend}
													onSend={this.sendPaymentPos}
													{...this.props}
												/>
											</div>
										)}
										*/}
										{this.state.showAdyenForm && this.state.terminal && (
											<div
												role='tabpanel'
												className='tab-pane active'
												id='adyen'>
												<FormAdyen
													signatureType={title}
													onDataAdyen={this.formDataAdyen}
													adyenPayment={this.state.adyenPayment}
													installments={planData.numberOfInstallment}
													isCompleted={this.handleIsCompleteAdyen}
													notSend={this.doNotSend}
													onSend={this.sendPaymentAdyen}
													terminal={this.state.terminal}
													fieldsTouched={this.fieldsTouched}
													totalValue={totalValue}
													onPixSelected={this.onPixSelected}
													{...this.props}
												/>
											</div>
										)}
										{/* {this.state.showDinheiroForm && (
												<div
													role='tabpanel'
													className={`tab-pane ${classActivePos}`}
													id='dinheiro'>
													<FormPosOrCash
														signatureType={title}
														onDataPosOrCash={this.formDataCash}
														posOrCashPayment={this.state.cashPayment}
														isCompleted={this.handleIsCompleteDinheiro}
														notSend={this.doNotSend}
														onSend={this.sendPaymentDinheiro}
														isCash={true}
													/>
												</div>
											)} */}
									</div>
									<NavBtn
										step={true}
										disabled={!this.state.isComplete}
										goForward={forwardFunction}
										goForwardText={'FINALIZAR COMPRA'}></NavBtn>
								</div>
							</div>
						</BoxSize>
						)}
					</FormWrapper>
				</Container>
			</ThemeProvider>
		);
	}
}

const mapStateToProps = actionObject => {
	return actionObject;
};

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			setCreditPayment,
			setBoletoPayment,
			getBankSlip,
			getOrderValue,
			setAllValues,
			userLogin,
			getPlanList
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(Pagamento);
